import gql from 'graphql-tag';
import { BannerFragment } from '../fragments/banner.fragment';

export const CREATE_ONE_BANNER = gql`
    mutation(
        $input: CreateOneBannerInput!
    ) {
        createOneBanner (input: $input) {
            ...BannerInfo
        }
    }
    ${BannerFragment}
`;